module.exports = __webpack_public_path__ + "img/bg_main0601.e8972658.png";